
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";


import TermsAndCondition from "crm/other/TermsCondition";
import { usePageTracking } from "helpers/usePageTracking";

export default function TermsAndConditions() {
    const seo = usePageTracking("termsAndConditions");
    return (
        <>
            {/* <Seo pageName="features" /> */}
            {seo && (
                <Seo
                    pageName="termsAndConditions"
                    title="Terms and Conditions | Sales Trackify"
                    description="Read the Terms and Conditions of Sales Trackify for using our CRM platform and services."
                    keywords="terms and conditions, CRM terms, sales trackify terms"
                    url="https://www.salestrackify.com/termsAndConditions"
                    image="/seo/trackify-preview.png"
                />
            )}

            <TermsAndCondition />
            <Footer1 />
            {/* <BackToTop /> */}
        </>
    );
}
